<div class="modal-header">
  <h4 class="modal-title" id="modal-basic-title">Beneficiarios</h4>
  <button type="button" class="close" aria-label="Close" (click)="activeModal.close()">
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<div class="modal-body">
  <div class="col-12">
    <div class="d-flex flex-row-reverse">
      <form [formGroup]="searchForm" class="d-flex w-100">
        <div class="input-group-prepend w-100">
          <input
            type="text"
            class="form-control flex-grow-1"
            id="inputQuestion"
            placeholder="Nombre"
            aria-label="questionHelp"
            aria-describedby="questionHelp"
            formControlName="nombre"
            (keydown.enter)="BuscarContacto()"
          />
          <span class="clear material-icons pt-2" (click)="limpiarCampo()">clear</span>
        </div>
        <button
          class="btn btn-outline-primary d-flex justify-content-center align-items-center ml-2"
          type="button"
          id="button-addon"
          (click)="BuscarContacto()"
        >
          <span class="material-icons font-18">search</span>
        </button>
      </form>
    </div>
    <hr class="my-3">
  </div>
  <ul class="list-group list-group-flush">
    <li class="list-group-item" *ngIf="contactos?.length === 0">
      <div class="fw-bold text-uppercase">
        No hay información que mostrar
      </div>
    </li>
    <li class="list-group-item d-flex justify-content-start align-items-center" *ngFor="let c of contactos"
      (click)="SeleccionarContacto(c)">
      <input class="form-check-input me-1" type="radio" name="contacto"
        [checked]="c.contactoId === contacto?.contactoId">
      <div class="d-flex justify-content-start align-items-center">
        <div class="rounded-circle mx-3">{{ c?.iniciales}}</div>
        <div class="ms-2 me-auto">
          <div class="fw-bold text-uppercase">{{c?.contactoNombre}}</div>
          <small class="d-block">{{c?.numeroCuenta}}</small>
          <small class="d-block text-muted">{{c?.contactoComplemento?.institucionNombre}}</small>
        </div>
      </div>
    </li>
  </ul>
</div>

<div class="modal-footer">
  <button type="button" class="btn btn-primary" [disabled]="!contacto" (click)="CerrarModal()">Seleccionar</button>
  <button type="button" class="btn btn-secondary" (click)="activeModal.close()">Cancelar</button>
</div>
